import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ExitWorkflowPanel = ({ departure, onClose }) => {
  const [tasks, setTasks] = useState([
    {
      id: 1,
      title: 'IT Equipment Recovery',
      description: 'Laptop, phone, access cards, and peripherals',
      assignedTo: 'IT Support',
      status: 'completed',
      dueDate: '2026-01-20',
      category: 'asset-recovery'
    },
    {
      id: 2,
      title: 'System Access Revocation',
      description: 'Email, HRIS, and all system access removal',
      assignedTo: 'IT Support',
      status: 'in-progress',
      dueDate: '2026-02-10',
      category: 'access-revocation'
    },
    {
      id: 3,
      title: 'Handover Documentation',
      description: 'Complete project handover and documentation transfer',
      assignedTo: 'Manager',
      status: 'in-progress',
      dueDate: '2026-02-12',
      category: 'knowledge-transfer'
    },
    {
      id: 4,
      title: 'Exit Interview Scheduling',
      description: 'Schedule and conduct exit interview',
      assignedTo: 'HR Coordinator',
      status: 'pending',
      dueDate: '2026-02-13',
      category: 'exit-interview'
    },
    {
      id: 5,
      title: 'Final Pay Calculation',
      description: 'Calculate leave balance, pro-rated benefits, and termination pay',
      assignedTo: 'Payroll Specialist',
      status: 'pending',
      dueDate: '2026-02-14',
      category: 'final-pay'
    },
    {
      id: 6,
      title: 'NASFUND Closure Notification',
      description: 'Submit NASFUND account closure documentation',
      assignedTo: 'Compliance Officer',
      status: 'pending',
      dueDate: '2026-02-15',
      category: 'compliance'
    },
    {
      id: 7,
      title: 'Tax Clearance Procedures',
      description: 'Complete PNG tax clearance requirements',
      assignedTo: 'Finance Team',
      status: 'pending',
      dueDate: '2026-02-15',
      category: 'compliance'
    },
    {
      id: 8,
      title: 'Employment Certificate Generation',
      description: 'Generate final employment certificate',
      assignedTo: 'HR Coordinator',
      status: 'pending',
      dueDate: '2026-02-15',
      category: 'documentation'
    }
  ]);

  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return 'bg-green-100 text-green-700 border-green-200';
      case 'in-progress':
        return 'bg-amber-100 text-amber-700 border-amber-200';
      case 'pending':
        return 'bg-gray-100 text-gray-700 border-gray-200';
      case 'overdue':
        return 'bg-red-100 text-red-700 border-red-200';
      default:
        return 'bg-gray-100 text-gray-700 border-gray-200';
    }
  };

  const getCategoryIcon = (category) => {
    switch (category) {
      case 'asset-recovery':
        return 'Package';
      case 'access-revocation':
        return 'Lock';
      case 'knowledge-transfer':
        return 'BookOpen';
      case 'exit-interview':
        return 'MessageSquare';
      case 'final-pay':
        return 'DollarSign';
      case 'compliance':
        return 'Shield';
      case 'documentation':
        return 'FileText';
      default:
        return 'Circle';
    }
  };

  const handleTaskStatusChange = (taskId, newStatus) => {
    setTasks(prev =>
      prev?.map(task =>
        task?.id === taskId ? { ...task, status: newStatus } : task
      )
    );
  };

  return (
    <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="bg-amber-100 p-2 rounded-lg">
            <Icon name="CheckSquare" size={24} className="text-amber-600" />
          </div>
          <div>
            <h2 className="text-xl font-bold text-gray-900">Exit Workflow Checklist</h2>
            <p className="text-sm text-gray-600">{departure?.employeeName}</p>
          </div>
        </div>
        <Button onClick={onClose} variant="outline" size="sm">
          <Icon name="X" size={16} className="mr-1" />
          Close
        </Button>
      </div>

      {/* Task List */}
      <div className="space-y-3">
        {tasks?.map(task => (
          <div key={task?.id} className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
            <div className="flex items-start justify-between mb-2">
              <div className="flex items-start gap-3 flex-1">
                <div className="bg-gray-100 p-2 rounded-lg">
                  <Icon name={getCategoryIcon(task?.category)} size={20} className="text-gray-600" />
                </div>
                <div className="flex-1">
                  <h3 className="text-base font-semibold text-gray-900 mb-1">{task?.title}</h3>
                  <p className="text-sm text-gray-600 mb-2">{task?.description}</p>
                  <div className="flex items-center gap-4 text-xs text-gray-500">
                    <span className="flex items-center gap-1">
                      <Icon name="User" size={14} />
                      {task?.assignedTo}
                    </span>
                    <span className="flex items-center gap-1">
                      <Icon name="Calendar" size={14} />
                      Due: {new Date(task?.dueDate)?.toLocaleDateString()}
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex flex-col items-end gap-2">
                <span
                  className={`px-3 py-1 rounded-full text-xs font-semibold border ${getStatusColor(
                    task?.status
                  )}`}
                >
                  {task?.status?.replace('-', ' ')?.toUpperCase()}
                </span>
                {task?.status !== 'completed' && (
                  <Button
                    onClick={() => handleTaskStatusChange(task?.id, 'completed')}
                    size="sm"
                    className="bg-amber-600 text-white"
                  >
                    <Icon name="Check" size={14} className="mr-1" />
                    Complete
                  </Button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExitWorkflowPanel;